import React from 'react';
import { Link } from 'react-scroll';
import { Button } from '@capcenter/shared';
import { ShareLink } from '../ShareLink/ShareLink';

interface DetailsHighlightProps {
	handleCloseDetails: () => void
	bpSM: any
  canonicalUrl: string
  PdfSaveElement: JSX.Element
}

const PropertyDetailsHeader = ({ handleCloseDetails, bpSM, PdfSaveElement, canonicalUrl }: DetailsHighlightProps) => {
	return (
		<nav className="property-details__header cc-bg--white-100 sticky-top">
			<div className="d-flex flex-nowrap justify-content-between max-w-xl m-auto">
				<div>
					<Button
						onClick={handleCloseDetails}
						resetText
						label={bpSM ? 'Back' : 'Back to Search'}
						icon="far fa-arrow-left"
						className="property-details__close font--base"
						variant="flat"
						color="secondary"
						size={bpSM ? 'sm' : 'md'}
					/>

					<Link
						containerId="propertydetails"
						to="overview"
						activeClass="active"
						className="link-unstyled"
						spy
						smooth
						offset={-44}
						isDynamic
						duration={500}
					>
						<Button
							resetText
							label="Overview"
							className="font--base"
							variant="flat"
							color="gray"
							size={bpSM ? 'sm' : 'md'}
						/>
					</Link>

					<Link
						containerId="propertydetails"
						to="listingDetails"
						activeClass="active"
						className="link-unstyled"
						spy
						smooth
						offset={-46}
						isDynamic
						duration={500}
					>
						<Button
							resetText
							label={bpSM ? 'Details' : 'Listing Details'}
							className="font--base"
							variant="flat"
							color="gray"
							size={bpSM ? 'sm' : 'md'}
						/>
					</Link>
				</div>
        <div className="d-flex flex-nowrap justify-content-between max-w-xl">
          {PdfSaveElement}
          <ShareLink canonicalUrl={canonicalUrl}/>
				</div>
			</div>
		</nav>
	);
};

export default PropertyDetailsHeader;
